import { ProjectDataProviderRepository } from '@goodt-common/dremio';
import { CoreError } from '@goodt-wcore/errors';

/**
 * @typedef {import('@goodt-common/data').IDatasetQuery} IDatasetQuery
 * @typedef {import('@goodt-common/data').IDatasetRequestProps} IDatasetRequestProps
 * @typedef {import('@goodt-common/data').QueryModel} QueryModel
 * @typedef {import('@goodt-common/data').QueryModelExtended} QueryModelExtended
 * @typedef {import('@goodt-common/data').QueryModelWithMetricsCustom} QueryModelWithMetricsCustom
 * @typedef {import('@goodt-common/data').IQueryModelStrategy} IQueryModelStrategy
 * @typedef {QueryModelExtended|QueryModel|QueryModelWithMetricsCustom} QueryModelOneOf
 */
export class RequestBuilder {
    /** @type {Omit<IDatasetRequestProps, 'query'>} */
    _options;

    /** @type {QueryModelExtended|QueryModel|QueryModelWithMetricsCustom} */
    _queryModel;

    /**
     * @private
     * @type {IQueryModelStrategy<IDatasetQuery, QueryModelOneOf>}
     */
    _queryModelStrategy;

    /**
     * @param {IDatasetRequestProps} requestOptions
     * @param {{ queryModelStrategy: IQueryModelStrategy<IDatasetQuery, QueryModelOneOf> }} options
     */
    constructor(requestOptions, { queryModelStrategy } = {}) {
        this._queryModelStrategy = queryModelStrategy;
        this.options = requestOptions;
    }

    /**
     * @param {IDatasetRequestProps} options
     */
    set options(options) {
        const { name, dataProviderId, limit, query } = options;
        this._options = { name, dataProviderId, limit };
        this._queryModel = this._queryModelStrategy.build(query);
    }

    /**
     * @return {Omit<import('./types').IDatasetRequestProps, 'query'>}
     */
    get options() {
        return this._options;
    }

    /**
     * @returns {import('./query-model').QueryModel}
     */
    get queryModel() {
        return this._queryModel;
    }

    /**
     * @returns {import('./client').IDatasetRequest}
     */
    build() {
        const { dataProviderId, limit } = this._options;
        const query = this._queryModel.prepared;
        const dataProvider =
            ProjectDataProviderRepository.getById(dataProviderId) ?? ProjectDataProviderRepository.getDefault();
        if (dataProvider == null) {
            throw new CoreError(
                `Data provider with id "${dataProviderId}" not found in "ProjectDataProviderRepository"`
            );
        }

        const { url } = dataProvider.connector;
        // @NOTE а если нет даже дефолта, что делать? Exception?
        return { query, url, limit };
    }
}
